const typography = {
  fontFamily: "Segoe UI, sans-serif",
  displayXLarge: {
    size: "2.625rem",
    lineHeight: "2.75rem",
    weight: 600,
  },
  displayLarge: {
    size: "1.75rem",
    lineHeight: "2rem",
    weight: 600,
  },
  displayMedium: {
    size: "1.625rem",
    lineHeight: "2rem",
    weight: 400,
  },
  displaySmall: {
    size: "1.25rem",
    lineHeight: "1.75rem",
    weight: 400,
  },
  heading: {
    size: "1rem",
    lineHeight: "1.5rem",
    weight: 600,
  },
  subHeading: {
    size: "0.75rem",
    lineHeight: "1rem",
    weight: 600,
  },
  caption: {
    size: "0.75rem",
    lineHeight: "1rem",
    weight: 400,
  },
  body: {
    size: "0.875rem",
    lineHeight: "1.25rem",
    weight: 400,
  },
  button: {
    size: "0.875rem",
    lineHeight: "1.25rem",
    weight: 500,
  },
};

export default typography;
